export const ADMIN_USERS_PAGE_SIZE = 25;

export function adminUsersResultRangeLabel(
  page: number,
  pageSize: number,
  total: number,
): string {
  if (total === 0) {
    return "Showing 0 users";
  }
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  if (start === end) {
    return `Showing ${start} of ${total}`;
  }
  return `Showing ${start}–${end} of ${total}`;
}

export function adminUsersPageCount(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}
